import { useField } from "formik";
import { useMemo } from "react";
import { cn } from "utils/helpers";
import { BidderQuestionnaireHeader } from "./BidderQuestionnaireHeader";
import { FormikRichTextEditor } from "newui/components/ui/RichTextEditor/FormikRichTextEditor";
import { rfxSubmission } from "newui/features/Rfx/Submission";
import { TextLength } from "newui/features/Rfx/types/component-types";

type TextAreaQuestionnaireProps = {
	className?: string;
	description?: string;
	disabled?: boolean;
	fieldValue: string;
	name: string;
	question: string;
	required: boolean;
	textLength?: TextLength;
	touchedField?: boolean;
};

export const TextAreaQuestionnaire = ({
	className,
	description,
	disabled,
	question,
	textLength = TextLength.SHORT,
	required,
	name,
	touchedField,
}: TextAreaQuestionnaireProps) => {
	const [, { error }] = useField(name);
	const characterLimit = rfxSubmission.helpers.getTextLengthValue(textLength);

	const subTitle = useMemo(() => {
		return `Maximum of ${characterLimit} characters.`;
	}, [characterLimit]);

	return (
		<div
			className={cn(className)}
			data-testid={`header-${name}`}
		>
			<BidderQuestionnaireHeader
				question={question}
				required={required}
				description={description}
				error={error}
				touchedField={touchedField}
			/>
			<div>
				<FormikRichTextEditor
					name={name}
					maxLength={characterLimit}
					disabled={disabled}
					className="my-4 w-full"
					required={required}
					placeholder="Enter your answer here..."
					subTitle={subTitle}
				/>
			</div>
		</div>
	);
};
